import { SelectionModel } from '@angular/cdk/collections';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Directive,
    inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { IModel } from '@klickdata/core/application';
import { MobileService } from '@klickdata/core/mobile';
import { AppScope } from '@klickdata/core/resource';
import {
    Filter,
    GlobalFilterProperty,
    TableFilterComponent,
    TableHttpService,
    TableSource,
} from '@klickdata/core/table';
import { User } from '@klickdata/core/user';
import { SelectModelBaseDirective } from '@klickdata/shared-components/src/selection-handler/select-model-base/select-model-base.component';
import { TableFilterExpansionPanelComponent } from '@klickdata/shared-components/src/table-filter-expansion-panel/table-filter-expansion-panel.component';
import { Subject, shareReplay, takeUntil } from 'rxjs';
@Directive()
export abstract class SelectableMatTableBase<T extends IModel>
    extends SelectModelBaseDirective<T>
    implements AfterViewInit, OnChanges, OnDestroy, OnInit
{
    @ViewChild(TableFilterComponent) filter: TableFilterComponent;
    @ViewChild('filterExpansion') filterExpansion: TableFilterExpansionPanelComponent;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    public destroy: Subject<boolean> = new Subject<boolean>();
    AppScope = AppScope;
    GlobalFilterProperty = GlobalFilterProperty;
    @Input() abstract columns: string[];
    // Filters which will not removed at all
    @Input() public fixedFilters: Filter<string | number>[] = [];
    @Input() authUser: User;
    public filtersTogglesInOnBtn = true;
    public dataSource = new TableSource<T>();
    public isMobile: boolean;
    public showActionHeader: boolean;
    public accessForm: FormGroup;
    sync_all_key = 'sync_all';
    attachKey = 'attach_ids';
    detachKey = 'detach_ids';
    referenceIdKey = 'id';
    referenceFilter: string;
    protected readonly fb = inject(FormBuilder);

    constructor(
        protected cdr: ChangeDetectorRef,
        protected mobileService: MobileService,
        protected listService: TableHttpService<T>
    ) {
        super(listService, mobileService);
        this.accessForm = this.fb.group({
            id: [],
            sync_all: [],
            attach_ids: [],
            detach_ids: [],
        });
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filter = this.filter;
        this.accessForm.valueChanges.pipe(takeUntil(this.destroy)).subscribe((value) => {
            this.showActionHeader = !!value.attach_ids?.length || value.sync_all === true;
            this.cdr.markForCheck();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['fixedFilters'] && !changes['fixedFilters'].firstChange && this.filter && this.dataSource.filter) {
            this.applyFixedFilters();
        }
    }
    get selection(): number[] {
        return !!this.accessForm.value.attach_ids?.length ? this.accessForm.value.attach_ids : [];
    }

    public applyFixedFilters(): void {
        if (!this.fixedFilters?.length) {
            this.dataSource.refresh();
        } else {
            this.filter.createOrUpdateFilter(this.fixedFilters);
        }
    }
    public refresh(): void {
        this.dataSource.refresh();
    }
    clearSelection(): void {
        this.accessForm.patchValue({
            attach_ids: [],
            detach_ids: [],
        });
    }

    updateSort(sort: Sort): void {
        this.sort.sort({ id: sort.active, start: sort.direction, disableClear: false });
    }

    ngOnDestroy() {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
